<template>
  <v-dialog persistent width="520" v-model="active" content-class="novedad-dialog-content">
    <v-card class="card dialog-card ui-module-card ui-module-fade-in-up" color="primary">
      <v-card-title class="font-weight-bold justify-center dialog-title ui-module-titlebar"
        >Registrar Novedad</v-card-title
      >
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-select
                class="modern-input"
                v-model="form.fk_idCatTipoNovedad"
                filled
                rounded
                dense
                color="secondary"
                background-color="primary"
                :items="tiposNovedad"
                item-value="id"
                item-text="title"
                item-color="secondary"
                :rules="required"
              >
                <template v-slot:label>Tipo de novedad <span class="red--text">*</span></template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-menu
                v-model="menuFecha"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="modern-input"
                    :value="fechaFormatted"
                    filled
                    rounded
                    dense
                    readonly
                    color="secondary"
                    background-color="primary"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    :rules="required"
                  >
                    <template v-slot:label>Fecha <span class="red--text">*</span></template>
                  </v-text-field>
                </template>
                <v-date-picker
                  class="modern-date-picker"
                  v-model="form.fecha"
                  locale="es"
                  color="secondary"
                  no-title
                  @input="menuFecha = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-textarea
                class="modern-input"
                v-model="form.descripcion"
                filled
                rounded
                dense
                color="secondary"
                background-color="primary"
                rows="8"
                :rules="required"
              >
                <template v-slot:label>Descripción <span class="red--text">*</span></template>
              </v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center pb-4 dialog-actions ui-module-actions">
        <v-btn text class="btn-cancel ui-module-btn-text-danger mx-8" @click="closeDialog()">Cancelar</v-btn>
        <v-btn
          color="secondary"
          class="btn-save ui-module-btn-solid mx-8"
          :loading="loading"
          :disabled="!isFormValid || loading"
          @click="save()"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { API_DATE_FORMAT } from '@/const'

export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      menuFecha: false,
      form: {
        fk_idCatTipoNovedad: null,
        fecha: null,
        descripcion: '',
      },
      required: [(v) => !!v || 'Este campo es requerido'],
    }
  },

  computed: {
    ...mapGetters({
      userId: 'getId',
      idPersonal: 'getIdPersonal',
    }),
    ...mapGetters('tipoNovedad', ['getTiposNovedad']),

    tiposNovedad() {
      return this.getTiposNovedad
    },

    fechaFormatted() {
      return this.form.fecha ? moment(this.form.fecha).format(API_DATE_FORMAT) : ''
    },

    isFormValid() {
      return !!this.form.fk_idCatTipoNovedad && !!this.form.fecha && this.form.descripcion.trim().length > 0
    },
  },

  methods: {
    ...mapActions('novedad', ['createNovedad']),

    resetForm() {
      this.form = { fk_idCatTipoNovedad: null, fecha: null, descripcion: '' }
      this.loading = false
    },

    closeDialog() {
      this.resetForm()
      this.$emit('close')
    },

    async save() {
      this.loading = true
      try {
        await this.createNovedad({
          idPersonal: this.idPersonal,
          novedad: {
            fk_idCatTipoNovedad: this.form.fk_idCatTipoNovedad,
            fecha: moment(this.form.fecha).format('YYYY/MM/DD'),
            fk_idUsuario: this.userId,
            descripcion: this.form.descripcion,
          },
        })
        this.closeDialog()
      } catch {
        // error ya manejado en el store (snackbar)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.btn-save {
  box-shadow: 0 8px 22px rgba(var(--v-secondary-base-rgb, 69, 170, 242), 0.34) !important;
}

::v-deep .modern-input .v-input__slot {
  background: rgba(8, 14, 19, 0.5) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 69, 170, 242), 0.2) !important;
  border-radius: 12px !important;
}

::v-deep .modern-input .v-label,
::v-deep .modern-input input,
::v-deep .modern-input textarea,
::v-deep .modern-input .v-icon {
  color: #e0f0ff !important;
}

::v-deep .modern-input.v-input--is-focused .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 69, 170, 242), 0.15) !important;
}

::v-deep .modern-date-picker {
  border: 1px solid rgba(var(--v-secondary-base-rgb, 69, 170, 242), 0.24) !important;
  border-radius: 14px;
  overflow: hidden;
  background: rgba(7, 12, 18, 0.86) !important;
}

::v-deep .modern-date-picker .v-date-picker-header,
::v-deep .modern-date-picker .v-date-picker-table,
::v-deep .modern-date-picker .v-picker__body {
  background: transparent !important;
}

::v-deep .modern-date-picker .v-btn {
  color: #d9ebff !important;
}
</style>
